import { render, staticRenderFns } from "./KickManagerDialog.vue?vue&type=template&id=4ec227e7&scoped=true&"
import script from "./KickManagerDialog.vue?vue&type=script&lang=ts&"
export * from "./KickManagerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KickManagerDialog.vue?vue&type=style&index=0&id=4ec227e7&prod&scoped=true&lang=scss&"
import style1 from "./KickManagerDialog.vue?vue&type=style&index=1&id=4ec227e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec227e7",
  null
  
)

export default component.exports